import { RepositoryFactory } from "repositories/factory";
import { ContactMonitoringEventRule } from "models/contact-monitoring-event-rule";
import { NOTIFICATION_STATUS_CD } from "models/monitoring-event-rule";
import {
  ContactMonitoringEventRulesStoreValidator,
} from "validators/contact-monitoring-event-rules";

const ContactMonitoringEventRulesRepository = RepositoryFactory.get("contact-monitoring-event-rules");

/* フォームアイテム */
class ContactMonitoringEventRulesController {
  constructor() {
    this._contactMonitoringEventRule = new ContactMonitoringEventRule();
    this._oldEventStartNotification = null;
    this._oldEventEndNotification = null;
  }

  get contactMonitoringEventRule() {
    return this._contactMonitoringEventRule;
  }

  set contactMonitoringEventRule(value) {
    this._contactMonitoringEventRule = value;
  }

  get oldEventStartNotification() {
    return this._oldEventStartNotification;
  }

  set oldEventStartNotification(value) {
    this._oldEventStartNotification = value;
  }

  get oldEventEndNotification() {
    return this._oldEventEndNotification;
  }

  set oldEventEndNotification(value) {
    this._oldEventEndNotification = value;
  }

  /* 算出プロパティ */
  isEventStartNotificationActive() {
    return this.contactMonitoringEventRule.eventStartNotification.statusCd
      === NOTIFICATION_STATUS_CD.ON;
  }

  isEventEndNotificationActive() {
    return this.contactMonitoringEventRule.eventEndNotification.statusCd
      === NOTIFICATION_STATUS_CD.ON;
  }

  /* イベントハンドラ */

  /* 初期化・登録処理 */
  static async createInstance(monitoringTarget, {
    defaultNotificationStatusCd = NOTIFICATION_STATUS_CD.ON,
  } = {}) {
    // 初期化(DBの値をフォーム反映)
    // 接点監視ルールの取得
    // TODO: 監視対象全体の設定を取得するようにする・・・現状は監視対象別のデータも取得している
    // インスタンス生成
    const contactMonitoringEventRulesController = new ContactMonitoringEventRulesController();

    // データが存在しない場合
    let contactMonitoringEventRule = null;
    if (monitoringTarget.isRegisterd()) {
      contactMonitoringEventRule
        = await ContactMonitoringEventRulesRepository.getMonitoringDeviceIdUnspecified(
          monitoringTarget.monitoringTargetId,
          {
            nullable: true,
          },
        );
    }

    if (contactMonitoringEventRule) {
      // 接点監視ルールが存在すればその値を反映する
      contactMonitoringEventRulesController.contactMonitoringEventRule = contactMonitoringEventRule;
    } else {
      // 存在しなければ、新しくインスタンスを生成する
      const newContactMonitoringEventRule
        = new ContactMonitoringEventRule(monitoringTarget.monitoringTargetId);
      newContactMonitoringEventRule.organizationId = monitoringTarget.organizationId;
      newContactMonitoringEventRule.projectId = monitoringTarget.projectId;

      // defaultNotificationStatuが
      newContactMonitoringEventRule.eventStartNotification.statusCd = defaultNotificationStatusCd;
      newContactMonitoringEventRule.eventEndNotification.statusCd = defaultNotificationStatusCd;

      contactMonitoringEventRulesController.contactMonitoringEventRule
        = newContactMonitoringEventRule;
    }

    // 初期状態の通知設定を保存
    contactMonitoringEventRulesController.oldEventStartNotification
      = contactMonitoringEventRulesController
        .contactMonitoringEventRule.eventStartNotification.copy();
    contactMonitoringEventRulesController.oldEventEndNotification
      = contactMonitoringEventRulesController
        .contactMonitoringEventRule.eventEndNotification.copy();

    return contactMonitoringEventRulesController;
  }

  createContactMonitoringEventRule() {
    // インスタンス生成（フォームの値からインスタンス生成）
    const contactMonitoringEventRule = this.contactMonitoringEventRule.copy();
    console.log("createContactMonitoringEventRule");
    console.log(contactMonitoringEventRule);

    // 通知がOFFの場合は、件名更新を行わない
    if (
      this.contactMonitoringEventRule.eventStartNotification.statusCd
        === NOTIFICATION_STATUS_CD.OFF
    ) {
      contactMonitoringEventRule.eventStartNotification.title
        = this.oldEventStartNotification.title;
    }
    if (
      this.contactMonitoringEventRule.eventEndNotification.statusCd
        === NOTIFICATION_STATUS_CD.OFF
    ) {
      contactMonitoringEventRule.eventEndNotification.title
        = this.oldEventEndNotification.title;
    }
    return contactMonitoringEventRule;
  }

  upsertValidate() {
    return ContactMonitoringEventRulesStoreValidator.validate(
      this.createContactMonitoringEventRule(),
    );
  }

  // 登録/更新
  async upsert(monitoringTargetId = null) {
    if (monitoringTargetId) {
      this.contactMonitoringEventRule.monitoringTargetId = monitoringTargetId;
    }
    const updateItem = await ContactMonitoringEventRulesRepository.upsert(
      this.createContactMonitoringEventRule(),
    );
    return updateItem;
  }
}

export {
  ContactMonitoringEventRulesController,
};
